import React, { useCallback } from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => props => {
  const [, { openDialog }] = hooks.useDialogs()
  const { openNotification } = hooks.useNotification()
  const [user] = hooks.useActiveUser()
  const [
    vehicle_count,
    load_count,
    passenger_name,
    passenger_number,
    luggage,
    companyservice_id
  ] = hooks.useFieldValues(['vehicle_count', 'load_count', 'passenger_name', 'passenger_number', 'luggage', 'service'])

  const [service] = hooks.useModel('companyservice', [companyservice_id], { single: true, populate: ['contract'] })
  const [ownCompanyUser] = hooks.useModelSearch('companyuser', 'get', {
    forced_filter: { user: user?.user_id, company: service?.contract?.company },
    watchers: [user?.user_id, service?.contract?.company],
    single: true,
    limit: 1,
  })

  const guest_booking = ownCompanyUser?.guest_booking
  const booking_level = ownCompanyUser?.booking_level
  const companyuser_id = ownCompanyUser?.companyuser_id
  const self_booking = ownCompanyUser?.self_booking
  const disabledPassenger = vehicle_count > 1

  const openPassengerPopup = useCallback(() => {
    if ((!!booking_level && !guest_booking && !self_booking && !!companyuser_id))
      openNotification('Vous ne pouvez pas modifier le passager', { variant: 'error' })
    else
      openDialog('passenger_form')
  }, [openDialog, booking_level, guest_booking, self_booking, companyuser_id])

  const mergedProps = {
    disabledPassenger,
    passenger_name,
    passenger_number,
    load_count,
    luggage,
    openPassengerPopup
  }

  return (
    <Component {...mergedProps} {...props} />
  )
}

export default withContainer